"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRecentlyViewedState = exports.defaultSavePropertiesState = void 0;
var SavePropertiesTranslate_init_1 = require("@/pages/saveproperties/states/SavePropertiesTranslate.init");
exports.defaultSavePropertiesState = {
    properties: [],
    t: SavePropertiesTranslate_init_1.defaultSavePropertiesTranslate,
    currentPage: 0,
    totalPage: 0,
    isLoading: false,
};
exports.defaultRecentlyViewedState = {
    properties: [],
    t: SavePropertiesTranslate_init_1.defaultRecentlyViewedTranslate,
    currentPage: 0,
    totalPage: 0,
    isLoading: false,
};
